<template>
  <div>
    <p class="mb-6 font-weight-black text-h4" v-bind:class="this.textColor">
      Not Found
    </p>
    <p class="mb-6 font-weight-medium" v-bind:class="this.textColor">
      URLをお確かめください…
    </p>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  components: {},
  data() {
    return {
      textColor: String,
    }
  },

  mounted: function () {
    var routeInstance = this.$route
    if (routeInstance.meta.textColorClass) {
      this.textColor = routeInstance.meta.textColorClass
    } else {
      this.textColor = 'black'
    }
  },
}
</script>
